import React from "react";

import Loader from 'react-loader-spinner'



const LoaderClass = ({ ...props }) => {

    let loaderObj = props.isLoading;
    return (
        <div className="loader-Div">
            <div className="loader-Father">
                <div>
                    <Loader
                        type="ThreeDots"
                        color="#01b9c1"
                        height={150}
                        width={150}
                        visible={true}
                    />
                </div>
                <div className="loader-Title">
                    {loaderObj.loadingTitle}
                </div>
                <div className="loader-Subtitle">
                    {loaderObj.loadingMessage}
                </div>
            </div>
        </div>
    );
};

export default LoaderClass;
